import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import ActivitiesTable from "../../../../../Activities/containers/ActivitiesTable";
import GenericModal from "../../../../../Modals/components/GenericModal";
import NewUserActivity from "../../../../../Activities/containers/NewUserActivity";
import OpenNewActivityModalButton from "./OpenNewActivityModalButton";
import { userHasPermission } from "../../../../../utils/accessTree";
import permissionCodes from "../../../../../utils/permissionCodes";
import { validDateGoals } from "../../../../../utils/helpers";

interface Props {
  periodo: string;
  idClub: number;
  month: number;
  year: number;
}

export default class ActividadesComponent extends Component<Props> {
  render() {
    const { idClub, month, year } = this.props;
    const validToday = validDateGoals(month, year);

    if (!idClub || !month || !year) {
      return null;
    }

    return (
      <>
        <Row>
          <Col>
            <ActivitiesTable
              clubId={String(idClub)}
              disabled={!validToday}
              month={month}
              year={year}
              hTitle={true}
            />
          </Col>
        </Row>

        <Row className="mt-3">
          <Col xs={9} />
          {userHasPermission(
            permissionCodes.TRACKING_VENTAS_MEMBRESIA_REGISTRO_NUEVAS_ACTIVIDADES
          ) && (
            <Col>
              <GenericModal
                Button={({ onClick }) => (
                  <OpenNewActivityModalButton
                    onClick={onClick}
                    disabled={!validToday}
                  />
                )}
                title="Nueva Actividad"
              >
                <NewUserActivity
                  disabled={!validToday}
                  clubId={String(idClub)}
                />
              </GenericModal>
            </Col>
          )}
        </Row>
      </>
    );
  }
}
